export enum DistributeActionType {
  Distribute = 'distribute',
  Close = 'close',
  Cancel = 'cancel'
}

export interface DistributeResultType {
  action: DistributeActionType;
}

export interface PostDisributeResults {
  isComplete: boolean;
  taskIDs: string[];
}
